import { Button } from '@/components/ui/button';
import useLanguage from '@/hooks/useLanguage';
import { cn } from '@/lib/utils';

const LanguageSetting = () => {
  const { language, setLanguage } = useLanguage();

  const handleClick = (target: 'kr' | 'en') => setLanguage(target);

  return (
    <div className="flex gap-2 items-center">
      <Button
        variant="secondary"
        onClick={() => handleClick('kr')}
        className={cn(language === 'ko' ? 'bg-border' : 'bg-transparent', 'text-xs shadow-none')}
      >
        KO
      </Button>
      <div className="w-px h-[16px] py-2 bg-gray-200" />
      <Button
        variant="secondary"
        onClick={() => handleClick('en')}
        className={cn(language === 'en' ? 'bg-border' : 'bg-transparent', 'text-xs shadow-none')}
      >
        EN
      </Button>
    </div>
  );
};

export default LanguageSetting;
